import { gql } from '@apollo/client';

export const QUERY_SCHOOL_CHILDREN = gql`
  query schoolChidren($asRegularUser: Boolean) {
    fetchMySchools(asRegularUser: $asRegularUser) {
      id
      attributes {
        name
        code
        schools {
          data {
            id
            attributes {
              name
              code
            }
          }
        }
      }
    }
  }
`;
